import { createContext } from 'react';

import { Context } from '../../../types';
import { PaymentMethod } from '../model';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<PaymentMethod>>(getContextDefaultValues(api));
